import { Label } from './label.js';
import { SelectField, type SelectOption } from './select.js';

export interface LabeledSelectFieldProps {
  id: string;
  /** Pass a translated string. */
  label: string;
  options: SelectOption[];
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  testId?: string;
}

/** Label + SelectField pair with the id/htmlFor/data-testid association wired once. */
export function LabeledSelectField({
  id,
  label,
  options,
  value,
  onChange,
  placeholder,
  testId,
}: LabeledSelectFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <SelectField
        id={id}
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        data-testid={testId}
      />
    </div>
  );
}
